import React from "react"

interface Row {
    col1?: React.ReactNode;
    col2: React.ReactNode;
    col3?: React.ReactNode;
}

const RowRoute = ({ col1, col2, col3 }: Row) => {
    return (
        <div className="display-flex gap-10 width-100pct align-items-end">
            {col1 ? <div className="width-120">{col1}</div> : null}
            <div className="flex-1-1">{col2}</div>
            {col3 ? <div>{col3}</div> : null}
        </div>
    )
}

export default RowRoute;